import { useState } from "react";
import { Link } from "react-router-dom";
import "./ResetBox.css"

const API_endpoint = "https://webdev.cse.buffalo.edu/hci/api/api/deekstra";
const requestPath = "/auth/request-reset";
const resetPath = "/auth/reset-password";

function ResetBoxEmail(props) {
    return (
        <div className="reset-box">
            {/* <div className="reset-box-header"> */}
            <div className = "lg-box-header">
                <h1>Reset Password</h1>
            </div>
                <div className="reset-directions">We'll send you an email to reset your password</div>
            {/* </div> */}
            
            <div className="input-wrapper">
                <input type="text" className="reset-input" name="email" value={props.email} onChange={props.saveEmailInput}></input>
                <label htmlFor="email" className="form-input-label">Email</label>
            </div>
            <button className="reset-button" onClick={() => props.sendEmail(props.email)}>Send Reset</button>
        </div>
    )
}

function ResetBoxUpdate(props) {
    return (
        <div className="reset-box">
            <div className = "lg-box-header">
                <h1>Reset Password</h1>
            </div>
                <div className="reset-directions">Please enter the token sent by email and your new password</div>
            <div className="input-wrapper">
                <input type="text" className="reset-input" name="TokenInput" onChange={props.saveTokenInput}></input>
                <label htmlFor="TokenInput" className="form-input-label">Token</label>
            </div>
            <div className="input-wrapper">
                <input type="password" className="reset-input" name="NewPassword" onChange={props.saveNewPassInput}></input>
                <label htmlFor="NewPassword" className="form-input-label">New Password</label>
            </div>
            <button className="reset-button" onClick={() => props.createNewPassword(props.token, props.newPass)}>Update Password</button>
        </div>
    )
}

function ResetBoxSuccess(props) {
    return (
        <div className="reset-box">
             <div className="reset-box-header">
                <h1>Success!</h1>
                <div className="reset-directions">Your password has been successfully reset!</div> <br />
                <div className="reset-directions">
                    Return to the&nbsp;
                    <Link to="/login">sign in</Link>
                    &nbsp;page<br />to access to your account</div>
            </div>
            
        </div>
    )
}

function RenderBox(props) {
    const type = props.type;
    switch (type) {
        case "email":
            return (<ResetBoxEmail email={props.email} saveEmailInput={props.saveEmailInput} sendEmail={props.sendEmail} />);
        case "update":
            return (<ResetBoxUpdate saveTokenInput={props.saveTokenInput} saveNewPassInput={props.saveNewPassInput} createNewPassword={props.createNewPassword} token={props.token} newPass={props.newPass}/>);
        case "success":
            return (<ResetBoxSuccess />);
        default:
            console.log("TYPE:", type);
    }
}

function ResetBox() {
    const [formType, SetFormType] = useState("email");
    const [token, SetToken] = useState('');
    const [email, SetEmail] = useState('');
    const [newPass, SetNewPass] = useState('');

    async function sendEmail(email) {
        const response = await fetch(`${API_endpoint}${requestPath}`, {
            method: "POST",
            headers: {
                'Accept': "*/*",
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: email
            })
        });
        console.log(response);
        const responseCode = response.status;
        
        switch(responseCode) {
            case 400:
                // Make error div visisble
                break;
            case 200:
                SetFormType("update");
                break;
            default:
                console.log(`Unknown response code: ${responseCode}`);
        }
    }
    
    async function createNewPassword(token, newPassword) {
        console.log(`Updating Password\nToken: ${token}\nNewPassword: ${newPassword}`);
        const response = await fetch(`${API_endpoint}${resetPath}`, {
            method: "POST",
            headers: {
                'Accept': "*/*",
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                token: token,
                password: newPassword
            })
        });
        console.log(response);

        const responseCode = response.status;
        switch(responseCode) {
            case 400:
                // Make error div visisble
                break;
            case 200:
                SetFormType("success");
                break;
            default:
                console.log(`Unknown response code: ${responseCode}`);
        }
    }
    
    function saveEmailInput(i) {
        const input = i.target.value;
        console.log("Email input:", input);
        SetEmail(input);
    }

    function saveTokenInput(i) {
        const input = i.target.value;
        console.log("Token input:", token);
        SetToken(input);
    }

    function saveNewPassInput(i) {
        const input = i.target.value;
        console.log("Password input:", newPass);
        SetNewPass(input);
    }
    


    return (
        <RenderBox 
            type={formType} SetFormType={SetFormType}
            token={token} SetToken={SetToken}
            email={email} SetEmail={SetEmail}
            newPass={newPass} setNewPass={SetNewPass}
            saveEmailInput={saveEmailInput} saveTokenInput={saveTokenInput} saveNewPassInput={saveNewPassInput}
            sendEmail={sendEmail} createNewPassword={createNewPassword}
         />
    )
}
export default ResetBox